import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Desktop = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Desktop' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,1 L23,1 L23,19 L1,19 L1,1 Z M5,23 L19,23 L5,23 Z M10,19 L10,23 L10,19 Z M14,19 L14,23 L14,19 Z' />
  </StyledIcon>
);
